module.exports = __webpack_public_path__ + "img/logo.f0c9f2e0.png";